<template>
  <div class="train-timeline">
    <img 
      src="@/images/TrainTimelineDeskX4.png" 
      alt="Train Timeline"
      class="timeline-image desktop"
    />
    <img 
      src="@/images/TrainTimelineMobX4.png" 
      alt="Train Timeline"
      class="timeline-image mobile"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TrainTimeline'
});
</script>

<style scoped>
.train-timeline {
  width: 100%;
  display: flex;
  justify-content: center;
}

.timeline-image {
  border-radius: 20px;
  width: 100%;
  max-width: 1288px;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}

@media (max-width: 768px) {
  .train-timeline {
    padding: 42px 16px;
  }

  .desktop {
    display: none;
  }
  
  .mobile {
    display: block;
    max-width: 680px;
    width: 100%;
  }
}
</style>
